export default __webpack_public_path__ + "static/media/Werfen_Docs_Partners_User_Manual_Rev01.ebadbdc0.pdf";